import {SelectOption} from "../ui/components/form/Select";
import {ClientUser} from "../API";

import type {UserSessionState} from "@stores/UserSessionState";


import {UserCard} from "../ui/components/UserCard";
import {getFullName} from "./userHelper";

export const getUserOptions = (users: ClientUser[]): SelectOption[] => {
    return users.map(user => ({
        value: user.id,
        label: <UserCard user={user} isEmail={false} size={24}></UserCard>,
        textForFilter: getFullName(user),
        plainLabel: getFullName(user),
    }));
}

export const getAllUserOptions = (userState: UserSessionState) => {
    const users = userState!.usersDS.activeUsersWithoutOwner;
    return getUserOptions(users);
}

